import { useEffect } from "react"
import useLazyQuery from "./useLazyQuery"

/**
 * The same as useLazyQuery, except query gets called once automatically
 * @param url
 * @param method
 * @returns
 */
const useQuery = <InputBody, OutputBody>(url: string, method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE" = "GET") => {
	const { query, data, loading, error } = useLazyQuery<InputBody, OutputBody>(url, method)
	useEffect(() => {
		query().catch((e) => {})
	}, [query])
	return { query, data, loading, error }
}
export default useQuery
